import { mapKeys, upperFirst } from 'lodash-es';

// eslint-disable-next-line import/prefer-default-export
export const formatData = (obj: Record<string, any>) => mapKeys(obj, (_, key) => `iframeData${upperFirst(key)}`);
